
 /**
 * Event `Core.Generic`
 *
 * @typedef {Object} MultSceneForApp~Core~Events~Generic
 * @property {string} type - type of event, has value `core.generic`
 * @property {Object} event - specific event object
 */

export default function createEventGeneric(event) {
    return {
        type: 'core.generic',
        event: event
    };
}
